import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { LicenseConfigureContext } from "..";
import LicenseConfigurationServices from "../../../../services/API/LicenseConfiguration";
import { toast } from "react-toastify";
import { validateLicense } from "../licenceTabs/Licenses";
import Editor from "../../../../components/common/Editor/Editor";
export default function AddLicenses({
  refetch,
  editData,
  setEdit,
  clearFilter,
  applyFilter,
  filtersAvailable,
  searchkey,
  handleSearch,
}) {
  const { show, setShow } = useContext(LicenseConfigureContext);
  const [name, setName] = useState(null);
  const [short, setShort] = useState(null);
  const [shortdes, setShortdes] = useState(); // 30-Jan-25 short description add for license karthikeyan
  const [sub_licenses, setSubLicenses] = useState(null); //28-03-2025 - sub licenses - Subha
  const [categories, setCategories] = useState([]);
  const [catId, setCatId] = useState(null);
  const [shortlist, setShortlist] = useState("");
  const [timer, setTimer] = useState(null);
  const [licenseContent, setLicenseContent] = useState(null);
  const [licenseImportantPoints, setLicenseImportantPoints] = useState(null);
  const [licenseFaq, setLicenseFaq] = useState(null);
  const [licenseDocumentContent, setLicenseDocumentContent] = useState(null);
  const [file, setFile] = useState(null);
  const [showBanner, setShowBanner] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [standardTAT, setStandardTAT] = useState("");
  //24-05-2025 - sub licenses - Subha
  const [detailsData, setDetailsData] = useState({
    name: "",
    ranges: [],
  })
  const [rangeErrors, setRangeError] = useState([]);

  useEffect(() => {
    const getCategories = async () => {
      const response =
        await LicenseConfigurationServices.getActiveCategoryList();
      if (response?.data?.length) {
        setCategories(response?.data);
      }
    };
    getCategories();
  }, []);

  useEffect(() => {
    if (editData) {
      setName(editData?.name);
      setShort(editData?.short_name);
      setShortdes(editData?.short_description); // 30-Jan-25 short description add for license karthikeyan
      setSubLicenses(editData?.sub_licenses); //28-03-2025 - sub licenses - Subha
      setCatId(editData?.license_category_id);
      setShortlist(editData?.shortlist);
      setLicenseContent(editData?.license_content);
      setLicenseImportantPoints(editData?.license_important_points)
      setLicenseFaq(editData?.license_faq)
      setLicenseDocumentContent(editData?.license_document_content)
      setFile(editData?.file_name);
      setDetailsData({
        ranges: editData?.sub_licenses?.map((range) => {
          return {
            ...range,
          };
        }),
      });
      setShowBanner(editData?.show_banner);
      setBannerImage(editData?.banner_image);
      setStandardTAT(editData?.standard_TAT);
    }
  }, [editData]);

  const createShortName = async (e) => {
    const { value } = e.target;
    setName(value);
    if (value.length === 0) {
      toast.error("Please enter license");
      clearTimeout(timer);
      setShort("");
      return;
    }

    clearTimeout(timer);

    const newTimer = setTimeout(() => {

      async function shortNameCreate() {
        try {
          const response = await LicenseConfigurationServices.createShortName({
            short_name: value,
            model_name: "License",
          });
          setShort(response?.data);
        } catch (e) {
          toast.error(e.message);
        }
      }
      shortNameCreate()
    }, 500);
    setTimer(newTimer);
  };

  const addLicense = async () => {
    const payload = {
      name,
      short_name: short,
      short_description: shortdes, // 30-Jan-25 short description add for license karthikeyan
      // sub_licenses: sub_licenses, //28-03-2025 - sub licenses - Subha
      sub_licenses: detailsData?.ranges,
      license_category_id: catId,
      shortlist,
      license_content: licenseContent,
      license_important_points: licenseImportantPoints,
      license_faq: licenseFaq,
      license_document_content: licenseDocumentContent,
      file: file,
      show_banner: showBanner,
      banner_image: bannerImage,
      static: 0
    };
    const error = validateLicense(payload);
    const subError = validateSubLicense(detailsData); //24-05-2025 - sub licenses - Subha
    if (error) {
      toast.error(error);
      return;
    } else if (subError) {
      return;
    }
    try {
      const response = await LicenseConfigurationServices.addLicense(payload);
      if (response) {
        toast.success("License created successfully");
        clearFilter();
        refetch();
        handleHide();
        setRangeError([]); //24-05-2025 - sub licenses - Subha
        setDetailsData({ ranges: [] });
      }
    } catch (e) {
      setDetailsData({ ranges: [] });
      console.log(e.message);
    }
  };
  const updateLicence = async () => {
    const payload = {
      name,
      short_name: short,
      short_description: shortdes, // 30-Jan-25 short description add for license karthikeyan
      // sub_licenses: sub_licenses, //28-03-2025 - sub licenses - Subha
      sub_licenses: detailsData?.ranges,
      license_category_id: catId,
      shortlist,
      license_content: licenseContent,
      license_important_points: licenseImportantPoints,
      license_faq: licenseFaq,
      license_document_content: licenseDocumentContent,
      file: file,
      show_banner: showBanner,
      banner_image: bannerImage,
      static: 0,
      standard_TAT: standardTAT,
    };
    const error = validateLicense(payload);
    const tatError = validateLicenseTAT();
    const subError = validateSubLicense(detailsData); //24-05-2025 - sub licenses - Subha
    if (error) {
      toast.error(error);
      return;
    } else if (subError) {
      return;
    } else if (tatError) {
      toast.error(tatError);
      return;
    }
    try {
      const response = await LicenseConfigurationServices.updateLicense(
        editData?.id,
        payload
      );
      if (response) {
        toast.success("License updated successfully");
        // clearFilter();
        handleHide();
        if (filtersAvailable) {
          applyFilter(1);
        } else if (searchkey) {
          handleSearch({ target: { value: searchkey } }, 1);
        } else {
          refetch();
        }
        setImmediate(null);
        setRangeError([]); //24-05-2025 - sub licenses - Subha
      }
    } catch (e) {
      toast.error(e);
    }
  };
  //24-05-2025 - sub licenses - Subha
  const validateSubLicense = (detailsData) => {
    let temprangeError = [];
    for (let i = 0; i < detailsData?.ranges?.length; i++) {
      if (!detailsData?.ranges[i]?.name) {
        temprangeError[i] = "Please enter sub license name";
        continue;
      }
      if (
        detailsData?.ranges?.findIndex(
          (item) =>
            item?.name?.toLowerCase() === detailsData?.ranges[i]?.name?.toLowerCase()
        ) !== i
      ) {
        temprangeError[i] = "Duplicate sub license name added";
        continue;
      }
    }
    setRangeError(temprangeError);
    return (temprangeError.length) ? true : false;
  }
  const validateLicenseTAT = () => {
    if (!standardTAT) return;
    if (standardTAT.length > 3 || standardTAT.length < 0)
      return "Standard tat should not be greater than three digit value.";
    if (String(standardTAT)[0] === "0")
      return "Please provide valid standard TAT";
  }
  const submitForm = () => {
    if (editData) {
      updateLicence();
    } else {
      addLicense();
    }
  };
  const handleHide = () => {
    setShow(null);
    setName(null);
    setShort(null);
    setCatId(null);
    setShortlist(null);
    setEdit(null);
    setLicenseContent(null);
    setLicenseImportantPoints(null)
    setLicenseFaq(null)
    setLicenseDocumentContent(null)
    setFile(null)
    setShortdes(null) // 30-Jan-25 short description add for license karthikeyan
    setSubLicenses(null)
    setDetailsData({ ranges: [] });
    setShowBanner(null);
    setBannerImage(null);
  };

  return (
    <Modal
      show={show === "licenses"}
      animation={false}
      onHide={handleHide}
      dialogClassName="modal-md"
    >
      <Modal.Header closeButton>
        <h3 className="modal-title">
          {editData ? "Edit License" : "Add License"}
        </h3>
      </Modal.Header>
      <Modal.Body style={{ height: 'auto', maxHeight: '70rem', overflowY: 'auto' }} className="add-license-model">
        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            License Name <span style={{ color: "red" }}> *</span>
          </label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter License Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Short Name <span style={{ color: "red" }}> *</span>
          </label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter Short Name"
            value={short}
            maxLength={3}
            onChange={(e) => setShort(e.target.value)}
          />
        </div>

        {/* 30-Jan-25 short description add for license karthikeyan */}
        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Short Description
          </label>
          <textarea
            type="text"
            className="form-control mb-3"
            placeholder="Enter Short Description"
            value={shortdes}
            onChange={(e) => setShortdes(e.target.value)}
          ></textarea>
        </div>
        {/* 30-Jan-25 short description add for license karthikeyan */}
        {/* <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Sub Licenses
          </label>
          <small style={{ color: "#7b818d" }}> (Ex: sampleone,sampletwo)</small>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter Sub licenses"
            value={sub_licenses}
            onChange={(e) => setSubLicenses(e.target.value)}
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Menu <span style={{ color: "red" }}> *</span>
          </label>

          <select
            className="form-control mb-3"
            id="Shortlist"
            value={catId}
            onChange={(e) => setCatId(e.target.value)}
          >
            <option value={""}>Choose Menu</option>
            {categories?.map((ct) => (
              <option key={ct?.id} value={ct?.id}>
                {ct.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Shortlist <span style={{ color: "red" }}> *</span>
          </label>

          <select
            className="form-control"
            id="Shortlist"
            value={shortlist}
            onChange={(e) => setShortlist(e.target.value)}
          >
            <option value="">Select Value</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
          <small>
            If marked as YES, the item will display on website home page
          </small>
        </div>
        <div className="form-group padding-top-10">
          <label htmlFor="tags"> Image </label>
          <div className="d-flex">
            <input
              type="file"
              className={
                typeof file === "string" ? `form-control file1` : `form-control`
              }
              placeholder="Name"
              onChange={(e) => setFile(e.target.files[0])}
            />
            {typeof file === "string" && (
              <input
                type="text"
                className="form-control file2"
                // disabled
                value={typeof file === "string" ? file : ""}
              />
            )}
          </div>

          <div className="note">
            <strong>Note:</strong> Accepted format : PNG,JPEG,SVG,WEBP,AVIF  Max size :2MB
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="tags">
            {" "}
            Show Banner <span style={{ color: "red" }}> *</span>
          </label>

          <select
            className="form-control"
            id="ShowBanner"
            value={showBanner}
            onChange={(e) => setShowBanner(e.target.value)}
          >
            <option value="">Select Value</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
          <small>
            If marked as YES, the item will display on website home page banner
          </small>
        </div>
        {showBanner == 1 && (
          <div className="form-group padding-top-10">
            <label htmlFor="tags"> Banner Image <span style={{ color: "red" }}> *</span> (Dimensions: 1625 px width × 600 px height)</label>
            <div className="d-flex">
              <input
                type="file"
                className={
                  typeof bannerImage === "string" ? `form-control file1` : `form-control`
                }
                placeholder="Name"
                onChange={(e) => setBannerImage(e.target.files[0])}
              />
              {typeof bannerImage === "string" && (
                <input
                  type="text"
                  className="form-control file2"
                  // disabled
                  value={typeof bannerImage === "string" ? bannerImage : ""}
                />
              )}
            </div>

            <div className="note">
              <strong>Note:</strong> Accepted format : PNG,JPEG,SVG,WEBP,AVIF  Max size :2MB
            </div>
          </div>
        )}
        {editData && (
          <div className="form-group">
            <label htmlFor="tags">
              {" "}
              Standard TAT
            </label>
            <input
                type="text"
                className="form-control mb-3"
                placeholder
                value={standardTAT}
                onChange={(e) => {
                  const value = e.target.value.replace(
                    /\D/g,
                    ""
                  );
                  setStandardTAT(value);
                }}
              />
          </div>
        )}
        {/* <div className="form-group">
          <label htmlFor="tags">
            {" "}
            License Content
          </label>
          <Editor
            data={licenseContent}
            setData={setLicenseContent}
            showSaveBtn={false}
            small={true}
          />
        </div> */}

        {/* <div className="form-group">
          <label htmlFor="tags">
            {" "}
            License Important Points 
          </label>
          <Editor
            data={licenseImportantPoints}
            setData={setLicenseImportantPoints}
            showSaveBtn={false}
            small={true}
          />
        </div> */}

        {/* <div className="form-group">
          <label htmlFor="tags">
            {" "}
            License FAQs 
          </label>
          <Editor
            data={licenseFaq}
            setData={setLicenseFaq}
            showSaveBtn={false}
            small={true}
          />
        </div> */}

        {/* <div className="form-group">
          <label htmlFor="tags">
            {" "}
            License Document Content <span style={{ color: "red" }}> *</span>
          </label>
          <Editor
            data={licenseDocumentContent}
            setData={setLicenseDocumentContent}
            showSaveBtn={false}
            small={true}
          />
        </div> */}
        { /*24-05-2025 - sub licenses - Subha*/}
        <div className="form-group ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>Sub Licenses</div>
            <button
              className=" button_new mt-0"
              onClick={() => {
                let newRanges = detailsData?.ranges;
                newRanges?.push({
                  name: "",
                });
                setDetailsData({
                  ...detailsData,
                  ranges: newRanges,
                });
                setRangeError([]);
              }}
            >
              <i className="fa fa-plus fa-fw" title="Add a Range"></i>
            </button>
          </div>
          <div>
            {detailsData?.ranges?.length ? (
              <div className="text-center ">
                {detailsData?.ranges?.map((range, index) => {
                  return (
                    <div>
                      <div className="d-flex " key={index}>
                        <div className="form-group w-100">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Sub Licenses"
                            value={detailsData?.ranges[index]?.name}
                            onChange={(e) => {
                              setRangeError([]);

                              const cleanedValue = e.target.value.replace(/[0-9]/g, "");
                              let newRanges = detailsData?.ranges
                                ? [...detailsData.ranges]
                                : [];
                              newRanges[index].name = cleanedValue;
                              setDetailsData({
                                ...detailsData,
                                ranges: newRanges,
                              });

                            }}
                          />
                        </div>
                        <div className="form-group">
                          <button
                            className="button_new mt-0 rounded-0 h-100"
                            title="Remove"
                            style={{
                              border: "1px solid #ccc",
                              ":&hover": "border: 1px solid ",
                            }}
                            onClick={() => {
                              const newArray = detailsData?.ranges?.filter(
                                (item, fIndex) => index !== fIndex
                              );
                              setDetailsData({
                                ...detailsData,
                                ranges: newArray,
                              });
                              setRangeError([]);
                            }}
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                      </div>
                      {rangeErrors[index] ? (
                        <div
                          className="txt-fail"
                          style={{ marginTop: "-10px", marginBottom: "10px" }}
                        >
                          {rangeErrors[index]}{" "}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center p-2 border ">No Sub Licenses Added</div>
            )}
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn button_new_success"
          onClick={submitForm}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}
